<div class="flex-column-center company-setting-dialog">
	<div class="row">
		<h3 i18n="@@companyAbout-companySettingEditConfirmation">Confirmation</h3>
	</div>
	<mat-divider></mat-divider>

	<div class="flex-row-center">
		<mat-dialog-content>
			<div class="padding-24" i18n="@@companyAbout-companySettingDialogContentMessage">
				Changes will be made to the company settings page, and these adjustments will impact all users. Are you sure you
				want to proceed?
			</div>
		</mat-dialog-content>
	</div>

	<mat-dialog-actions class="row-right">
		<button
			mat-button
			class="secondary-button"
			(click)="onCancelClicked()"
			i18n="@@companyAbout-companySettingDialogCancel"
			data-automation-id="company-about-dialog-cancel-button"
		>
			Cancel
		</button>
		<button
			mat-button
			class="primary-button"
			(click)="onConfirmClicked()"
			i18n="@@companyAbout-companySettingDialogConfirm"
			data-automation-id="company-about-dialog-confirm-button"
		>
			Confirm
		</button>
	</mat-dialog-actions>
</div>
